export { default as Pending } from './Pending';
export { default as Routing } from './Routing';
export { default as Shorts } from './Shorts';
export { default as Waves } from './Waves';



// WEBPACK FOOTER //
// ./src/views/index.js